export default __webpack_public_path__ + "static/media/sign-in-bg.233a6fa0.svg";